import type { StreamingBlock } from "@storytell/streaming";
import { getBlockContent } from "@storytell/streaming";
import { createMemo } from "solid-js";
import { BaseBlockPreview } from "./internal/BaseBlockPreview";

interface BlockPreviewProps {
  block: StreamingBlock;
  onClick: () => void;
}

export const BlockPreview = (props: BlockPreviewProps) => {
  const content = createMemo(() => {
    // For streaming blocks, get accumulated content from granular store
    const existingContent = getBlockContent(props.block.blockId);
    if (existingContent) {
      return existingContent;
    }
    // For completed blocks, use finalContent
    if (props.block.finalContent?.type === "text") {
      return props.block.finalContent.text;
    }
    return "";
  });

  return (
    <div data-renderer="block-preview">
      <BaseBlockPreview block={props.block} onClick={props.onClick} variant="blue">
        <div class="w-full">
          <pre class="font-mono text-sm whitespace-pre-wrap">{content()}</pre>
        </div>
      </BaseBlockPreview>
    </div>
  );
};
